/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const initialValues = {
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  policyNumber: '',
  phone: '',
  tcNo: '',
  username: '',
  changepassword: '',
  acceptTerms: false,
};

const registrationSchema = Yup.object().shape({
  firstname: Yup.string().min(3, 'Minimum 3 symbols').max(50, 'Maximum 50 symbols').required('First name is required'),
  email: Yup.string().email('Wrong email format').min(3, 'Minimum 3 symbols').max(50, 'Maximum 50 symbols').required('Email is required'),
  lastname: Yup.string().min(3, 'Minimum 3 symbols').max(50, 'Maximum 50 symbols').required('Last name is required'),
  policyNumber: Yup.string().min(3, 'Minimum 3 symbols').max(50, 'Maximum 50 symbols').required('Policy number is required'),
  username: Yup.string().min(3, 'Minimum 3 symbols').max(50, 'Maximum 50 symbols').required('username is required'),
  phone: Yup.string().min(10, 'Minimum 10 symbols').max(10, 'Maximum 10 symbols').required('Phone number is required'),
  password: Yup.string().min(3, 'Minimum 6 symbols').max(50, 'Maximum 50 symbols').required('Password is required'),
  tcNo: Yup.string().min(11, 'Minimum 11 symbols').max(11, 'Maximum 11 symbols').required('T.C is required'),
  changepassword: Yup.string()
    .required('Password confirmation is required')
    .when('password', {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
    }),
  acceptTerms: Yup.bool().required('You must accept the terms and conditions'),
});

export function Registration() {
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
    },
  });

  return (
    <form className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework" noValidate id="kt_login_signup_form" onSubmit={formik.handleSubmit}>
      {/* begin::Heading */}
      <div className="mb-10 text-center">
        {/* begin::Title */}
        <h1 className="text-dark mb-3">Create an Account</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className="text-gray-400 fw-bold fs-4">
          Already have an account?
          <Link to="/auth/login" className="link-primary fw-bolder" style={{ marginLeft: '5px' }}>
            Forgot Password ?
          </Link>
        </div>
        {/* end::Link */}
      </div>
      {/* end::Heading */}

      {/* begin::Action */}
      {/* <button type="button" className="btn btn-light-primary fw-bolder w-100 mb-10">
        <img alt="Logo" src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')} className="h-20px me-3" />
        Sign in with Google
      </button> */}
      {/* end::Action */}

      <div className="d-flex align-items-center mb-10">
        <div className="border-bottom border-gray-300 mw-50 w-100"></div>
        <span className="fw-bold text-gray-400 fs-7 mx-2">OR</span>
        <div className="border-bottom border-gray-300 mw-50 w-100"></div>
      </div>

      {formik.status && (
        <div className="mb-lg-15 alert alert-danger">
          <div className="alert-text font-weight-bold">{formik.status}</div>
        </div>
      )}
      <div className="fv-row mb-7">
        <label className="form-label fw-bolder text-dark fs-6">Email</label>
        <input
          placeholder="Email"
          type="email"
          autoComplete="off"
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            },
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* begin::Form group Firstname */}
      <div className="row fv-row ">
        <div className="col-xl-6">
          <label className='class="form-label fw-bolder text-dark fs-6'>Adı</label>
          <input
            placeholder="Adınız"
            type="text"
            autoComplete="off"
            {...formik.getFieldProps('firstname')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.firstname && formik.errors.firstname,
              },
              {
                'is-valid': formik.touched.firstname && !formik.errors.firstname,
              },
            )}
          />
          {formik.touched.firstname && formik.errors.firstname && (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">
                <span role="alert">{formik.errors.firstname}</span>
              </div>
            </div>
          )}
        </div>
        <div className="col-xl-6">
          {/* begin::Form group Lastname */}
          <div className="fv-row mb-5">
            <label className="form-label fw-bolder text-dark fs-6">Soyadı</label>
            <input
              placeholder="Soyadınız"
              type="text"
              autoComplete="off"
              {...formik.getFieldProps('lastname')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.lastname && formik.errors.lastname,
                },
                {
                  'is-valid': formik.touched.lastname && !formik.errors.lastname,
                },
              )}
            />
            {formik.touched.lastname && formik.errors.lastname && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">
                  <span role="alert">{formik.errors.lastname}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group Email */}
      <div className="mb-10 fv-row">
        <div className="mb-1">
          <label className="form-label fw-bolder text-dark fs-6">T.C Kimlik Numarası</label>
          <div className="position-relative mb-3">
            <input
              type="number"
              placeholder="T.C Kimlik Numaranız"
              autoComplete="off"
              {...formik.getFieldProps('tcNo')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.tcNo && formik.errors.tcNo,
                },
                {
                  'is-valid': formik.touched.tcNo && !formik.errors.tcNo,
                },
              )}
            />
            {formik.touched.tcNo && formik.errors.tcNo && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block ">
                  <span role="alert">{formik.errors.tcNo}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="mb-10 fv-row">
        <div className="mb-1">
          <label className="form-label fw-bolder text-dark fs-6">Telefon Numarası</label>
          <div className="position-relative mb-3">
            <input
              type="number"
              placeholder="Telefon Numaranız"
              autoComplete="off"
              {...formik.getFieldProps('phone')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.phone && formik.errors.phone,
                },
                {
                  'is-valid': formik.touched.phone && !formik.errors.phone,
                },
              )}
            />
            {formik.touched.phone && formik.errors.phone && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block ">
                  <span role="alert">{formik.errors.phone}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* end::Form group */}
      <div className="mb-10 fv-row">
        <div className="mb-1">
          <label className="form-label fw-bolder text-dark fs-6">Poliçe Numarası</label>
          <div className="position-relative mb-3">
            <input
              type="number"
              placeholder="Poliçe Numaranız"
              autoComplete="off"
              {...formik.getFieldProps('policyNumber')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.policyNumber && formik.errors.policyNumber,
                },
                {
                  'is-valid': formik.touched.policyNumber && !formik.errors.policyNumber,
                },
              )}
            />
            {formik.touched.policyNumber && formik.errors.policyNumber && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block ">
                  <span role="alert">{formik.errors.policyNumber}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* begin::Form group Password */}
      <div className="mb-10 fv-row">
        <div className="mb-1">
          <label className="form-label fw-bolder text-dark fs-6">Kullanıcı Adı</label>
          <div className="position-relative mb-3">
            <input
              type="text"
              placeholder="Kullanıcı adınız"
              autoComplete="off"
              {...formik.getFieldProps('username')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.username && formik.errors.username,
                },
                {
                  'is-valid': formik.touched.username && !formik.errors.username,
                },
              )}
            />
            {formik.touched.username && formik.errors.username && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">
                  <span role="alert">{formik.errors.username}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mb-10 fv-row" data-kt-password-meter="true">
        <div className="mb-1">
          <label className="form-label fw-bolder text-dark fs-6">Şifre</label>
          <div className="position-relative mb-3">
            <input
              type="password"
              placeholder="Şifreniz"
              autoComplete="off"
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                },
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">
                  <span role="alert">{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* end::Form group */}

      {/* begin::Form group Confirm password */}
      <div className="fv-row mb-5">
        <label className="form-label fw-bolder text-dark fs-6">Şifreyi Onayla</label>
        <input
          type="password"
          placeholder="Şifrenizi onaylayın"
          autoComplete="off"
          {...formik.getFieldProps('changepassword')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
            },
            {
              'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
            },
          )}
        />
        {formik.touched.changepassword && formik.errors.changepassword && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.changepassword}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className="fv-row mb-10">
        <div className="form-check form-check-custom form-check-solid">
          <input className="form-check-input" type="checkbox" id="kt_login_toc_agree" {...formik.getFieldProps('acceptTerms')} />
          <label className="form-check-label fw-bold text-gray-700 fs-6" htmlFor="kt_login_toc_agree">
            <Link to="/auth/terms" className="ms-1 link-primary">
              Şartlar ve koşulları
            </Link>{' '}
            kabul ediyorum.
          </label>
          {formik.touched.acceptTerms && formik.errors.acceptTerms && (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">
                <span role="alert">{formik.errors.acceptTerms}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className="text-center">
        <button type="submit" id="kt_sign_up_submit" className="btn btn-lg btn-primary w-100 mb-5" disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}>
          {!loading && <span className="indicator-label">Kayıt Ol</span>}
          {loading && (
            <span className="indicator-progress" style={{ display: 'block' }}>
              Lütfen bekleyin.. <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
        <Link to="/auth/login">
          <button type="button" id="kt_login_signup_form_cancel_button" className="btn btn-lg btn-light-primary w-100 mb-5">
            İptal
          </button>
        </Link>
      </div>
      {/* end::Form group */}
    </form>
  );
}
